module.exports = __webpack_public_path__ + "img/bosspack-active.aedeb512.svg";